var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDuplicate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3337 3.66536V0.998698C10.3337 0.821887 10.2634 0.652318 10.1384 0.527293C10.0134 0.402269 9.8438 0.332031 9.66699 0.332031H1.00033C0.823515 0.332031 0.653946 0.402269 0.528921 0.527293C0.403897 0.652318 0.33366 0.821887 0.33366 0.998698V9.66536C0.33366 9.84218 0.403897 10.0117 0.528921 10.1368C0.653946 10.2618 0.823515 10.332 1.00033 10.332H3.66699V12.994C3.66699 13.3647 3.96633 13.6654 4.33833 13.6654H12.9957C13.0838 13.6655 13.1712 13.6481 13.2527 13.6144C13.3342 13.5807 13.4082 13.5313 13.4706 13.4689C13.5329 13.4066 13.5824 13.3325 13.6161 13.251C13.6498 13.1696 13.6671 13.0822 13.667 12.994L13.665 4.3367C13.665 3.96603 13.3657 3.66536 12.9937 3.66536H10.3337ZM9.00033 3.66536H4.33833C3.96766 3.66536 3.66699 3.9647 3.66699 4.3367V8.9987H1.66699V1.66536H9.00033V3.66536Z",
    fill: "#797F86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/duplicate.4e48065f8c62d4cea7d7b16bdbcedca6.svg";
export { ForwardRef as ReactComponent };